import { PageKey } from "@apis:ui_branding/ui_branding";
import { SVGInternalIcon } from "@components:SVGInternalIcon";
import { alpha, Box, Tooltip } from "@mui/material";
import { useTranslation } from "react-i18next";

import { PRESET_ICONS } from "./constants";

interface PresetIconGridProps {
  page: PageKey;
  selectedKey: string | null | undefined;
  onSelect: (key: string) => void;
}

export const PresetIconGrid = ({
  page,
  selectedKey,
  onSelect,
}: PresetIconGridProps) => {
  const { t } = useTranslation();
  return (
    <Box
      sx={{
        display: "flex",
        gap: 0.75,
      }}
    >
      {PRESET_ICONS[page].map(({ key }) => {
        const isSelected = selectedKey === key;
        return (
          <Tooltip
            key={key}
            title={t(`preferences.uiBranding.iconLabels.${page}.${key}`)}
            placement="top"
            arrow
          >
            <Box
              onClick={() => onSelect(key)}
              sx={{
                flex: 1,
                aspectRatio: "1",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                bgcolor: "white",
                border: "2px solid",
                borderColor: isSelected ? "primary.main" : "grey.300",
                borderRadius: 1.5,
                cursor: "pointer",
                transition: "all 0.15s",
                "&:hover": {
                  borderColor: isSelected ? "primary.main" : "grey.400",
                  bgcolor: isSelected
                    ? (theme) => alpha(theme.palette.primary.main, 0.08)
                    : "grey.50",
                },
                ...(isSelected && {
                  bgcolor: (theme) => alpha(theme.palette.primary.main, 0.08),
                }),
              }}
            >
              <SVGInternalIcon
                icon={key as Parameters<typeof SVGInternalIcon>[0]["icon"]}
                sx={{
                  width: 22,
                  height: 22,
                  color: isSelected ? "primary.main" : "text.secondary",
                }}
              />
            </Box>
          </Tooltip>
        );
      })}
    </Box>
  );
};
